/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');
var Backbone = require('backbone');

var Scaffold = require('common/layout/Scaffold');
var NavUtils = require('psa-core/util/nav');

var GetLicenseIdentifiers = require('../services/GetLicenseIdentifiers');
var GetDocumentTypesByDepartment = require('common/services/GetDocumentTypesByDepartment');
var GetEntityFlaggedStatus = require('../../entity-dashboard/services/GetEntityFlaggedStatus');

var NonDepLicenseInitiateCorrespondenceView = require('../views/NonDepLicenseInitiateCorrespondenceView');

module.exports = function(entityId, licenseId) {
  NProgress.start();
  NProgress.set(0.6);

  $.when(
    GetLicenseIdentifiers(licenseId),
    GetDocumentTypesByDepartment('NON_DEPOSITORY'),
    GetEntityFlaggedStatus(entityId)
  )
    .done(function(licenseIdentifiers, documentTypes, hasFlagged) {
      NavUtils.navigate('nondep/entity/' + entityId + '/license/' + licenseId + '/initiate-correspondence');
      Scaffold.content.show(
        new NonDepLicenseInitiateCorrespondenceView({
          model: new Backbone.Model({
            entityId: entityId,
            licenseId: licenseId,
            licenseIdentifiers: licenseIdentifiers,
            documentTypes: documentTypes,
            hasFlagged: hasFlagged
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
